<div  fxLayout="column" fxLayoutAlign="center center"   fxFill>
    <div  fxLayout="column" fxLayoutAlign="center center"  fxFlex>
        <div  class="mat-padding">
            <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
        </div>
        <div class="mat-padding" fxLayout="column" fxLayoutAlign="center center">
            <div class="mat-headline"> Authentification en cours ...</div>
        </div>
    </div>
</div>